export function slugify(string) {
    if (typeof string !== 'string') {
        return '';
    }

    return string
        .trim()
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/\./g, '')
        .replace(/([^a-zA-Z0-9\._-]+)/, '')
        .replace(/-{2,}/g, '-');
}
